import { string, number, object, date } from "yup";
import { errMsg } from "../Account/useAddUpdateAddressForm/utils/addressFormSchema";
import { emailValidationSchema } from "../Shared/utils/formValidation";
export const MESSAGE_LIMIT = 500;
export var GiftCardText;
(function (GiftCardText) {
    GiftCardText["TITLE"] = "Gift Card";
    GiftCardText["DEFAULT_DESCRIPTION"] = "Please fill out the form below to complete your Gift Card purchase.";
    GiftCardText["GIFT_CARD_AMOUNT"] = "Gift card amount";
    GiftCardText["DELIVERY_DATE"] = "Delivery date";
    GiftCardText["TO"] = "To:";
    GiftCardText["FIRST_NAME"] = "First name";
    GiftCardText["LAST_NAME"] = "Last name";
    GiftCardText["EMAIL"] = "Email";
    GiftCardText["FROM"] = "From:";
    GiftCardText["MESSAGE"] = "Message";
    GiftCardText["MESSAGE_FOR_RECIPIENT"] = "Message for recipient";
    GiftCardText["ENTER_VALID_AMOUNT"] = "Please enter a valid amount";
    GiftCardText["ENTER_VALID_DATE"] = "Please enter a valid delivery date";
    GiftCardText["ENTER_VALID_EMAIL"] = "Please enter a valid email";
    GiftCardText["POSITIVE_AMOUNT"] = "Amount must be greater than 0.";
    GiftCardText["CONTINUE"] = "Continue";
})(GiftCardText || (GiftCardText = {}));
export const giftCardFormSchema = object({
    giftCardAmount: number()
        .typeError(GiftCardText.ENTER_VALID_AMOUNT)
        .required(errMsg(GiftCardText.GIFT_CARD_AMOUNT))
        .positive(GiftCardText.POSITIVE_AMOUNT),
    deliveryDate: date().typeError(GiftCardText.ENTER_VALID_DATE).required(errMsg(GiftCardText.DELIVERY_DATE)),
    toFirstName: string().required(errMsg(GiftCardText.FIRST_NAME)),
    toLastName: string().required(errMsg(GiftCardText.LAST_NAME)),
    toEmail: emailValidationSchema,
    fromFirstName: string().required(errMsg(GiftCardText.FIRST_NAME)),
    fromLastName: string().required(errMsg(GiftCardText.LAST_NAME)),
    message: string().required(errMsg(GiftCardText.MESSAGE_FOR_RECIPIENT)),
});
